"use client";

import { useMemo, useState } from "react";
import Link from "next/link";
import { ChevronDown, ChevronUp } from "lucide-react";
import { AppPageShell } from "@/components/layout/AppPageShell";
import { Button } from "@/components/ui/Button";
import { SUPPORT_FAQS } from "@/lib/config/customerSupport";

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [query, setQuery] = useState("");

  const faqs = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return SUPPORT_FAQS;
    return SUPPORT_FAQS.filter(
      faq =>
        faq.question.toLowerCase().includes(q) ||
        faq.answer.toLowerCase().includes(q)
    );
  }, [query]);

  return (
    <AppPageShell
      title="자주 묻는 질문"
      description="결제, 피드백, 레슨 관련 궁금한 점을 먼저 확인해 보세요."
    >
      <input
        value={query}
        onChange={e => setQuery(e.target.value)}
        placeholder="검색어를 입력하세요"
        className="mb-4 w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm outline-none focus:border-violet-400"
      />

      <div className="space-y-2">
        {faqs.map((faq, index) => (
          <div
            key={faq.id}
            className="overflow-hidden rounded-xl border border-gray-200 bg-white"
          >
            <button
              type="button"
              className="flex w-full items-center justify-between px-4 py-3.5 text-left"
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <span className="pr-3 text-sm font-medium text-gray-900">
                {faq.question}
              </span>
              {openIndex === index ? (
                <ChevronUp className="h-4 w-4 shrink-0 text-gray-400" />
              ) : (
                <ChevronDown className="h-4 w-4 shrink-0 text-gray-400" />
              )}
            </button>
            {openIndex === index && (
              <div className="border-t border-gray-100 px-4 py-3 text-sm leading-relaxed text-gray-600">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-8 rounded-2xl border border-violet-100 bg-violet-50 p-5 text-center">
        <p className="text-sm text-gray-700">원하는 답을 찾지 못하셨나요?</p>
        <div className="mt-3 flex justify-center gap-2">
          <Link href="/contact">
            <Button variant="primary" size="sm">
              1:1 문의하기
            </Button>
          </Link>
        </div>
      </div>
    </AppPageShell>
  );
}
